import { SvgIcon } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

const HeartIconSvg = styled(SvgIcon)`
  fill: ${(props) => props.color ?? "rgb(255, 255, 255)"};
  stroke: white;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
`;

export function HeartIcon(props) {
  return (
    <HeartIconSvg {...props}>
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    </HeartIconSvg>
  );
}
